/* eslint-disable camelcase */
import { useState } from 'react';
import styles, { listItemTextPrimary } from './styles';
import { Box, Button, Dialog, DialogActions, Divider, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { ArrowDropDown, ArrowRightAltOutlined, CancelPresentationRounded, CandlestickChartOutlined, DirectionsRunRounded, ReadMoreOutlined, RotateLeftRounded, SwapVertOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { checkHydraulicsAdmin } from '../../../../utils/checkPermissions';

const HydraulicsRunCopyModal = ({
  rowData,
  onCloseClick,
  isOpen,
  confirmAction,
  handleAction
}) => {
  const classes = styles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedType, setSelectedType] = useState(rowData.type);
  const open = Boolean(anchorEl);
  const user = useSelector((state) => state.currentUser);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  const addHydraulics = (type) => {
    setSelectedType(type);
  };

  const getLabelForType = (type) => {
    switch (type) {
      case 'hydraulicsRun': return 'Hydraulics Run';
      case 'stripping': return 'Stripping';
      case 'rollover': return 'Rollover';
      case 'displacement': return 'Displacement';
      case 'parametricAnalysis': return 'Parametric Analysis';
      default: return 'Select Type';
    }
  };

  const typeIconMap = {
    hydraulicsRun: <DirectionsRunRounded fontSize="small" />,
    stripping: <SwapVertOutlined fontSize="small" />,
    rollover: <RotateLeftRounded fontSize="small" />,
    displacement: <ReadMoreOutlined fontSize="small" sx={{ transform: 'rotate(90deg)' }} />,
    parametricAnalysis: <CandlestickChartOutlined fontSize="small" />,
  };

  return (
        <Dialog
            open={isOpen}
            onClose={onCloseClick}
            maxWidth={'lg'}
            fullWidth={true}
            className={classes.dialogModal}
        >
            <Box className={classes.dialogTitle}>
                <Typography variant="subtitle1" className={classes.headerTitle}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography variant="subtitle1" color="textPrimary">
                                    {`Copying ${rowData?.name}`}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item>
                            <IconButton onClick={onCloseClick}>
                                <CancelPresentationRounded fontSize="large" />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Typography>

            </Box>
            <Divider />
            <Grid container spacing={2} sx={{ paddingTop: '4%' }}>
                <Grid item xs={12}>
                    <Box style={{
                      marginLeft: '2%'
                    }}>
                        <Typography variant="h6" fontWeight={'500'} >
                            Create the copy as
                        </Typography>
                    </Box>
                  <Box display="flex" justifyContent="center" mt={2} gap={1.5}>
                      <Box display="flex" alignItems="center" sx={{
                        opacity: 0.6,
                        pointerEvents: 'none',
                      }} marginRight={'2%'} gap={0.5}>
                          {typeIconMap[rowData?.type] ?? null}
                          <Typography variant="body2" color="textPrimary">
                              {getLabelForType(rowData.type)}
                          </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <ArrowRightAltOutlined/>
                      </Box>
                      <Button onClick={handleMenuClick} disabled={!checkHydraulicsAdmin(user?.type, user?.accessLevels)}>
                          <Box display="flex" alignItems="center" gap={0.5}>
                              <ArrowDropDown />
                              {typeIconMap[selectedType] ?? null}
                              <Typography variant="body2" color="textPrimary">
                                  {getLabelForType(selectedType)}
                              </Typography>
                          </Box>
                      </Button>
                  </Box>

                    <Menu anchorEl={anchorEl} open={open} onClose={handleCloseDropDown}>
                        <MenuItem
                            onClick={() => {
                              handleCloseDropDown();
                              addHydraulics('hydraulicsRun');
                            }}
                        >
                            <ListItemIcon>
                                <DirectionsRunRounded fontSize="medium" />
                            </ListItemIcon>
                            <ListItemText primary="Hydraulics Run" primaryTypographyProps={listItemTextPrimary} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                              handleCloseDropDown();
                              addHydraulics('stripping');
                            }}
                        >
                            <ListItemIcon>
                                <SwapVertOutlined fontSize="medium" />
                            </ListItemIcon>
                            <ListItemText primary="Stripping" primaryTypographyProps={listItemTextPrimary} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                              handleCloseDropDown();
                              addHydraulics('rollover');
                            }}
                        >
                            <ListItemIcon>
                                <RotateLeftRounded fontSize="medium" />
                            </ListItemIcon>
                            <ListItemText primary="Rollover" primaryTypographyProps={listItemTextPrimary} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                              handleCloseDropDown();
                              addHydraulics('displacement');
                            }}
                        >
                            <ListItemIcon>
                                <ReadMoreOutlined fontSize="medium" sx={{ transform: 'rotate(90deg)' }} />
                            </ListItemIcon>
                            <ListItemText primary="Displacement" primaryTypographyProps={listItemTextPrimary} />
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                              handleCloseDropDown();
                              addHydraulics('parametricAnalysis');
                            }}
                        >
                            <ListItemIcon>
                                <CandlestickChartOutlined fontSize="medium" />
                            </ListItemIcon>
                            <ListItemText primary="Parametric Analysis" primaryTypographyProps={listItemTextPrimary} />
                        </MenuItem>
                    </Menu>
                </Grid>
            </Grid>
            <Grid container item justifyContent='center' margin='4% 0'>
                <DialogActions>
                    <Button
                        style={{
                          backgroundColor: '#444',
                          width: '120px',
                          cursor: confirmAction ? 'wait' : '',
                          opacity: confirmAction ? 0.6 : 1,
                        }}
                        onClick={() => {
                          handleAction(rowData, selectedType);
                        }}
                    >
                        Create Copy
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
  );
};
HydraulicsRunCopyModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rowData: PropTypes.object,
  confirmAction: PropTypes.bool,
  handleAction: PropTypes.func
};
HydraulicsRunCopyModal.defaultProps = {
  selectedJob: {}
};

export default HydraulicsRunCopyModal;
